import { CustomFilter } from "@/types/custom-filter";

import { FalconDocumentsPaymentStatus } from "@/enums/falcon/documents/falcon-documents-payment-status.enum";

import i18n from "@/i18n";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents payment status filter
 */
export const falconDocumentsPaymentStatusFilter: CustomFilter = {
  falconDocumentsPaymentStatus(value: any): string {
    value = +value as FalconDocumentsPaymentStatus;
    if (value === FalconDocumentsPaymentStatus.All) {
      value = i18n.t(I18nMessageKey.SharedFiltersDocumentsPaymentStatusAllText);
    } else if (value === FalconDocumentsPaymentStatus.Settled) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentStatusSettledText
      );
    } else if (value === FalconDocumentsPaymentStatus.Unsettled) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentStatusUnsettledText
      );
    } else if (value === FalconDocumentsPaymentStatus.UnsettledExpired) {
      value = i18n.t(
        I18nMessageKey.SharedFiltersDocumentsPaymentStatusUnsettledExpiredText
      );
    } else {
      value = "";
    }
    return value;
  }
};
